// DefaultLayout.tsx
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

import theme from '../global/themes';

const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default DefaultLayout;
